var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"text-center",attrs:{"color":_vm.themeColor}},[_c('div',{staticClass:"logo-wrapper"},[_c('v-img',{attrs:{"width":_vm.logoWidth,"height":_vm.logoHeight,"src":_vm.logoSrc}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }